import {StyleSheet} from 'react-native';
import Typography from '../../../../shared/constants/Typography';
import Colors from '../../../../shared/theme/colors';

export const createInputStyles = (theme: any) =>
  StyleSheet.create({
    container: {
      width: Typography.fullWidth,
    },

    innerContainer: {
      gap: Typography.gap.gap8,
    },
    innerContainerStyle: {
      gap: Typography.gap.gap6,
    },
    label: {
      color: theme.text,
      fontFamily: Typography.fontFamily.inter,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
    },

    input: {
      flex: 1,
      minHeight: Typography.height.height44,
      paddingHorizontal: Typography.padding.padding14,
      paddingVertical: Typography.padding.padding12,
      borderRadius: Typography.radius.radius8,
      borderWidth: Typography.borderWidth.borderWidth1,
      borderColor: theme.inputBorder,
      backgroundColor: theme.inputBG,
      color: theme.text,
      textAlignVertical: 'center',
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
      fontFamily: Typography.fontFamily.inter,
    },

    placeholderInput: {
      flex: 1,
      minHeight: Typography.height.height44,
      paddingHorizontal: Typography.padding.padding14,
      paddingVertical: Typography.padding.padding12,
      borderRadius: Typography.radius.radius8,
      borderWidth: Typography.borderWidth.borderWidth1,
      borderColor: theme.inputBorder,
      backgroundColor: theme.inputBG,
      color: theme.inputPlaceHolder,
      textAlignVertical: 'center',
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.regular,
      fontFamily: Typography.fontFamily.inter,
    },
    disabledInput: {
      borderColor: 'transparent',
      backgroundColor: theme.diabledBG,
      color: theme.diabledText
    },
    nonEditableDisabledInput: {
      fontSize: Typography.fontSize.fontSize16,
      minHeight: 0,
      borderColor: theme.inputDisabledBorder,
      borderWidth: 0,
      paddingHorizontal: 0,
      paddingVertical: 0,
    },
    textArea: {
      minHeight: 120,
      textAlignVertical: 'top',
    },
    iconSpace: {
      paddingRight: 40,
    },

    errorText: {
      marginTop: Typography.margin.margin4,
      color: Colors.black,
      fontSize: Typography.fontSize.fontSize12,
    },

    inputWrapper: {
      position: 'relative',
      justifyContent: 'center',
    },

    iconContainer: {
      position: 'absolute',
      right: 12,
      bottom: 12, // important for textarea
      justifyContent: 'center',
      alignItems: 'center',
    },

    eyeIcon: {
      height: Typography.height.height20,
      width: Typography.width.width20,
    }
  });
